import { indexData } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按分类浏览你感兴趣的吃瓜专题</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-center gap-3 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-base`}></i>
              </span>
              <div className="min-w-0">
                <p className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </p>
                <p className="text-xs text-foreground-400">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}